import { httpClient, ApiResponse } from '@/utils';
import {
  staticAkeneoSyncEndpoints,
  IAkeneoSyncEntityDTO,
  IBaseAkeneoSyncResponse,
  IAkeneoSyncProductsDTO,
  getSyncEndpoints,
  IGetEntitiesInfoResponse,
  IAkeneoCleanSyncDTO,
  IProductSyncResponse,
  IAkeneoSyncSpecificProductDTO,
  IGetCleanupDatabaseDataResponse,
} from '@/models/akeneoSync.model';

class AkeneoSyncAPI {
  static getEntities(): ApiResponse<IGetEntitiesInfoResponse> {
    const { GET_ENTITIES_INFO } = staticAkeneoSyncEndpoints;
    return httpClient.get<IGetEntitiesInfoResponse>(GET_ENTITIES_INFO);
  }

  static getProductSync(): ApiResponse<IProductSyncResponse> {
    const { PRODUCT_SYNC_RESULTS } = staticAkeneoSyncEndpoints;
    return httpClient.get<IProductSyncResponse>(PRODUCT_SYNC_RESULTS);
  }

  static getCleanupDatabaseData(): ApiResponse<IGetCleanupDatabaseDataResponse> {
    const { GET_CLEAN_UP_DATA } = staticAkeneoSyncEndpoints;
    return httpClient.get<IGetCleanupDatabaseDataResponse>(GET_CLEAN_UP_DATA);
  }

  static syncEntity(data: IAkeneoSyncEntityDTO): ApiResponse<IBaseAkeneoSyncResponse> {
    const { SYNC_ENTITY } = staticAkeneoSyncEndpoints;
    return httpClient.post<IBaseAkeneoSyncResponse>(SYNC_ENTITY, data);
  }

  static cleanSync(data: IAkeneoCleanSyncDTO): ApiResponse<IBaseAkeneoSyncResponse> {
    const { CLEAN_SYNC } = staticAkeneoSyncEndpoints;
    return httpClient.post<IBaseAkeneoSyncResponse>(CLEAN_SYNC, data);
  }

  static syncProducts({ type, ...data }: IAkeneoSyncProductsDTO): ApiResponse<IBaseAkeneoSyncResponse> {
    const { SYNC_BY_ENTITY } = getSyncEndpoints({ type });
    return httpClient.post<IBaseAkeneoSyncResponse>(SYNC_BY_ENTITY, data);
  }

  static syncSpecificProduct(data: IAkeneoSyncSpecificProductDTO): ApiResponse<IBaseAkeneoSyncResponse> {
    const { SYNC_SINGLE_PRODUCT } = staticAkeneoSyncEndpoints;
    return httpClient.post<IBaseAkeneoSyncResponse>(SYNC_SINGLE_PRODUCT, data);
  }
}

export default AkeneoSyncAPI;
